var _circle, _path, _rect, _rect2, _rect3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 30,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 22,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,17 C23,13 20,10 20,6 C20,4 22,2 25,4 C28,2 30,4 30,6 C30,10 27,13 25,17 Z",
    fill: "#FFFFFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 22,
    width: 8,
    height: 15,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 12,
    height: 4,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 6,
    height: 4,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "46%",
    fontSize: 5,
    fontFamily: "Arial, sans-serif",
    textAnchor: "middle",
    fill: "#FFFFFF"
  }, "Foundry")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundary);
export default __webpack_public_path__ + "static/media/foundary.3bfc4eab27bd355efbb5ced0aa98c01c.svg";
export { ForwardRef as ReactComponent };